import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonMenuButton,
  IonNote,
  IonPage,
  IonTitle,
  IonToolbar,
  IonGrid,
  IonCol,
  IonRow,
  IonIcon,
  IonSpinner,
  IonList,
  IonListHeader,
  IonSkeletonText,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import { useParams } from "react-router";
import SchedulerNavbar from "../../../../components/Scheduler/SchedulerNavbar/SchedulerNavbar";
import "./Locations.css";

import React, { useMemo } from "react";
import Footer from "../../../../components/Checkout/Footer";
import { closeCircleOutline, navigateCircleOutline } from "ionicons/icons";

import { Geolocation } from "@capacitor/geolocation";
import Constants from "../../../../lib/Constants";
import API from "../../../../lib/API";
import _ from "underscore";
import DateUtils from "../../../../lib/DateUtils";
import PubSub from "../../../../lib/PubSub";
import Event from "../../../../lib/Event";
import MapUtils from "../../../../lib/MapUtils";
import WindowUtils from "../../../../lib/WindowUtils";
import StorageUtils from "../../../../lib/StorageUtils";
import SegmentUtils from "../../../../lib/SegmentUtils";
import SEOHeaders from "../../../../components/SEOHeaders";
import LocationSearchInputV2 from "../../../../components/Map/LocationSearchInputV2";

class LocationsV2 extends React.Component<{ history: any }> {
  state: any = {
    requestingLocation: false,
    allStores: [],
    googleMap: null,
    mode: "selectstore",
    filterOption: "all",
  };

  googleMap: any = React.createRef();
  formSection: any = React.createRef();
  listSection: any = React.createRef();

  _loadLead(lead: any) {
    if (!lead) {
      return;
    }

    //console.log(lead);

    this.setState({
      lead,
    });

    if (lead?.zipCode) {
      this.setState({
        zipCode: lead?.zipCode,
      });

      //this.submitLocation(lead?.zipCode, false);
    }
  }

  setError(key: any, msg: any) {
    if (!msg) {
      this.setState({
        [key]: "",
      });

      return;
    }

    this.setState({
      [key]: msg,
    });

    setTimeout(() => {
      this.setError(key, "");
    }, 5000);
  }

  componentDidMount(): void {
    this.loadStores();
    this.requestLocation();
  }

  loadStores() {
    this.setState({
      loadingStores: true,
    });

    return new Promise((resolve, reject) => {
      API.getStores()
        .then(
          (data: any) => {
            let stores = data?.data?.data?.stores?.length
              ? data?.data?.data?.stores
              : [];

            stores = _.filter(stores, (store: any) => {
              return (
                store &&
                (DateUtils.storeIsPrelaunch(store) ||
                  DateUtils.storeIsLive(store))
              );
            });

            stores = _.filter(stores, (store: any) => {
              return store?.type == "retail";
            });

            stores = stores.map((st: any) => {
              st.name = st.name?.replace("Project LeanNation", "PLN").trim();

              if (st?.location?.address?.city) {
                st.location.address.city = st.location.address.city?.trim();
              }

              return st;
            });

            stores = _.sortBy(stores, "name");

            //console.log(stores);

            this.setState({
              allStores: stores,
            });

            //console.log(location);

            if (this.state.location?.geographic) {
              this.loadStoreResults(
                stores,
                this.state.location?.geographic,
                this.state.location?.zipCode,
              );
            } else {
              this.setState({
                filteredStores: stores,
              });
            }

            resolve(stores);
          },
          (e) => {
            console.error(e);

            reject(e);
          },
        )
        .finally(() => {
          this.setState({
            loadingStores: false,
          });
        });
    });
  }

  getStoreDistance(coordinates: any, store: any) {
    let distance: any = MapUtils.calculateDistanceInMiles(
      coordinates?.lat,
      coordinates?.lng,
      store?.location?.geographic?.lat,
      store?.location?.geographic?.lng,
    );

    distance = Math.round(distance * 100) / 100;

    return distance;
  }

  async reverseGeocodeLocation(lat: any, lng: any) {
    let res: any = await API.reverseGeocodeLatLng(lat, lng);

    //console.log(res);

    let result = res?.data?.data?.geocode?.results?.length
      ? res?.data?.data?.geocode?.results[0]
      : null;
    let geographic = {
      lat: lat,
      lng: lng,
    };

    let zipCode = result?.address_components?.find((component: any) => {
      return component?.types?.includes("postal_code");
    });

    if (zipCode) {
      zipCode = zipCode?.short_name;
    } else {
      zipCode = null;
    }

    this.setState(
      {
        location: {
          result,
          geographic,
          zipCode,
        },
        deliveryLocation: {
          result,
          geographic,
          zipCode,
        },
        filterOption: "nearby",
      },
      () => {
        this.loadStoreResults(
          this.state.allStores,
          this.state.location?.geographic,
          this.state.location?.zipCode,
        );
      },
    );
  }

  loadStoreResults(stores: any, coordinates: any, zipCode: string) {
    //console.log(stores, coordinates);

    let filteredStores = _.filter(stores, (store: any) => {
      let distance = this.getStoreDistance(coordinates, store);

      //console.log(distance);

      return distance <= 25;
    });

    //console.log(coordinates, filteredStores);

    if (zipCode) {
      let inTerritoryStores = _.filter(filteredStores, (store: any) => {
        return store?.dedicatedTerritories?.includes(zipCode);
      });

      //console.log(inTerritoryStores, zipCode);

      let outOfTerritoryStores = _.filter(filteredStores, (store: any) => {
        return !store?.dedicatedTerritories?.includes(zipCode);
      });

      //console.log(outOfTerritoryStores);

      inTerritoryStores = _.sortBy(inTerritoryStores, (store: any) => {
        return this.getStoreDistance(coordinates, store);
      });

      outOfTerritoryStores = _.sortBy(outOfTerritoryStores, (store: any) => {
        return this.getStoreDistance(coordinates, store);
      });

      filteredStores = _.union(inTerritoryStores, outOfTerritoryStores);
    }

    this.setState({
      filteredStores: filteredStores,
    });
  }

  requestLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        this.reverseGeocodeLocation(
          position.coords.latitude,
          position.coords.longitude,
        );
      });
    }
  }

  selectStore(store: any) {
    this.props.history.push(`/schedule/${store?._id}/nc-consult`);
  }

  componentDidUpdate(
    prevProps: Readonly<{}>,
    prevState: Readonly<{}>,
    snapshot?: any,
  ): void {}

  render() {
    return (
      <IonPage>
        <SEOHeaders title="Choose A Location"></SEOHeaders>
        <SchedulerNavbar
          showSupportOptions={false}
          onSupportChat={() => {}}
          onSupportCall={() => {}}
          activeStep={1}
          showBackButton={false}
        ></SchedulerNavbar>
        <IonContent style={{ background: "var(--white)" }}>
          <div
            className="pb-lg-4"
            style={{
              background: "var(--white)",
            }}
          >
            {/** Desktop View */}
            <div
              style={{
                maxWidth: 800,
                margin: "auto",

                overflow: "hidden",
              }}
              className="px-4 px-sm-6"
            >
              <div className="mt-4 mx-auto min-h-[70vh]">
                <p
                  className={`text-gray-900 mb-[0.5rem] text-center font-[SourceSerif] text-2xl`}
                >
                  Schedule Your Free Consultation
                </p>
                <p
                  className={`text-gray-900 text-center text-[17px] leading-5`}
                >
                  Search below to schedule a free consultation at a store near
                  you.
                </p>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <div className="mt-3">
                    {this.state.location ? (
                      <>
                        <div className="rounded relative">
                          <div className="absolute left-2 top-3 sm:top-3.5 sm:left-2.5 text-lg h-[2rem] w-[2rem]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="h-[1.3rem] w-[1.3rem]"
                            >
                              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                              <circle cx="12" cy="10" r="3" />
                            </svg>
                          </div>
                          <p className="block whitespace-nowrap overflow-hidden text-ellipsis w-full text-base sm:text-md pr-[2.25rem] pl-[2.25rem] rounded-tr rounded-tl border-0 py-2.5 sm:py-3 text-gray-900 shadow-sm outline-0 border-[1px] border-gray-100 placeholder:text-gray-400 transition-all focus:border-orange-500 sm:leading-6 rounded-br rounded-bl">
                            {this.state.location?.result?.formatted_address}
                          </p>
                          <div
                            onClick={() => {
                              this.setState({
                                location: null,
                                deliveryLocation: null,
                                filterOption: "all",
                              });
                            }}
                            className="cursor-pointer absolute right-2.5 top-3 sm:top-3.5 sm:right-3 text-2xl h-[2rem] w-[1.5rem]"
                          >
                            <IonIcon
                              icon={closeCircleOutline}
                              className="text-gray-900"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <LocationSearchInputV2
                          onChange={(data: any) => {
                            console.log("change", data);
                          }}
                          onSelect={(data: any) => {
                            console.log("select", data);

                            this.setState({
                              filterOption: "nearby",
                            });

                            let zipCode =
                              data?.result?.address_components?.find(
                                (component: any) => {
                                  return component?.types?.includes(
                                    "postal_code",
                                  );
                                },
                              );

                            if (zipCode) {
                              zipCode = zipCode?.short_name;
                            } else {
                              zipCode = null;
                            }

                            this.setState(
                              {
                                location: {
                                  ...data,
                                  zipCode,
                                },
                                deliveryLocation: {
                                  ...data,
                                  zipCode,
                                },
                              },
                              () => {
                                this.loadStoreResults(
                                  this.state.allStores,
                                  this.state.location?.geographic,
                                  this.state.location?.zipCode,
                                );
                              },
                            );
                          }}
                        ></LocationSearchInputV2>
                      </>
                    )}
                  </div>

                  {this.state.locationFormError ? (
                    <p className="mt-2 text-red-500 text-sm text-center">
                      {this.state.locationFormError}
                    </p>
                  ) : null}
                </form>
                <div className="my-3 h-[1px] bg-gray-100"></div>
                <IonSegment
                  disabled={this.state.loadingStores}
                  value={this.state.filterOption}
                  onIonChange={(e: any) => {
                    this.setState({
                      filterOption: e.detail.value,
                    });
                  }}
                  mode={"ios"}
                >
                  <IonSegmentButton
                    disabled={!this.state.location}
                    value="nearby"
                  >
                    <IonLabel>Nearby</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="all">
                    <IonLabel>All Locations</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
                <div className="mt-3">
                  {this.state.loadingStores ? (
                    <>
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                      <IonSkeletonText
                        animated
                        className="w-full rounded-lg h-[98px] mb-3"
                      />
                    </>
                  ) : (
                    <div>
                      {this.state.filterOption == "nearby" ? (
                        <>
                          {this.state.filteredStores?.length ? (
                            <>
                              {this.state.filteredStores?.map((store: any) => {
                                return (
                                  <div
                                    onClick={() => {
                                      this.selectStore(store);
                                    }}
                                    className={`p-3 cursor-pointer items-center flex gap-x-3 rounded-lg border border-gray-100 mb-3 ${
                                      this.state.submitting
                                        ? "bg-gray-50 text-gray-300"
                                        : "text-gray-900"
                                    }`}
                                    key={store?._id}
                                  >
                                    <div className="grow">
                                      <p className="text-base font-[SourceSerif]">
                                        {store?.name}
                                        {this.state.location?.geographic ? (
                                          <span className="pl-1.5 text-sm relative -top-[1px]">
                                            (
                                            {this.getStoreDistance(
                                              this.state.location?.geographic,
                                              store,
                                            )?.toFixed(1)}{" "}
                                            mi)
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                      <p className="text-sm">
                                        {
                                          store?.location?.address
                                            ?.formattedAddress
                                        }
                                      </p>
                                    </div>
                                    <div>
                                      {this.state.submitting == store?._id ? (
                                        <IonSpinner name="dots"></IonSpinner>
                                      ) : null}
                                      {!this.state.submitting ? (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          className="h-8 w-8"
                                        >
                                          <path d="m9 18 6-6-6-6" />
                                        </svg>
                                      ) : null}
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              <div className="rounded-lg border border-gray-100 p-3">
                                <p className="text-base text-lg text-center mb-2 font-[SourceSerif]">
                                  No Locations Nearby (Yet!)
                                </p>
                                <p className="text-base text-center">
                                  We're growing fast so stay tuned, a PLN
                                  community could be coming your way soon!
                                </p>
                                <div className="mt-3">
                                  <button
                                    onClick={() => {
                                      this.setState({
                                        filterOption: "all",
                                      });
                                    }}
                                    className="w-full text-orange-500 px-4 mt-2 py-2"
                                  >
                                    View All Locations
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {this.state.allStores?.map((store: any) => {
                            return (
                              <div
                                onClick={() => {
                                  this.selectStore(store);
                                }}
                                className={`p-3 cursor-pointer items-center flex gap-x-3 rounded-lg border border-gray-100 mb-3 ${
                                  this.state.submitting == store?._id
                                    ? "bg-gray-50 text-gray-300"
                                    : "text-gray-900"
                                }`}
                                key={store?._id}
                              >
                                <div className="grow">
                                  <p className="text-base font-[SourceSerif]">
                                    {store?.name}
                                    {this.state.location?.geographic ? (
                                      <span className="pl-1.5 text-sm relative -top-[1px]">
                                        (
                                        {this.getStoreDistance(
                                          this.state.location?.geographic,
                                          store,
                                        )?.toFixed(1)}{" "}
                                        mi)
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                  <p className="text-sm">
                                    {store?.location?.address?.formattedAddress}
                                  </p>
                                </div>
                                <div>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="h-8 w-8"
                                  >
                                    <path d="m9 18 6-6-6-6" />
                                  </svg>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      )}
                    </div>
                  )}
                </div>

                {this.state.noStoreFound ? (
                  <>
                    <div className="mt-3">
                      <p className="mt-0 mb-1 text-center">
                        Unfortunately we don't have a store in your area.
                      </p>
                      <p className="mt-0 mb-3 text-center">
                        Enter a different zip code to view other PLN stores or
                        provide your name below and we'll notify you when we're
                        coming to your area!
                      </p>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          <Footer bgWhite={true}></Footer>
        </IonContent>
      </IonPage>
    );
  }
}

export default LocationsV2;
